export default __webpack_public_path__ + "static/media/account_balance.6e629ad6.svg";